import { Column } from "./Column";
import { Row } from "./Row";
import { TextComponent } from "./TextComponent";

interface SectionCardProps {
	img?: string;
	titulo?: string;
	descripcion?: string;
	index?: number;
	children?: React.ReactNode;
	classNameImg?: string;
	responsive?: boolean;
}

export const SectionCard: React.FC<SectionCardProps> = ({
	img,
	titulo,
	descripcion,
	index,
	children,
	classNameImg = "md:w-2/5 max-md:h-24 md:aspect-square object-cover rounded-md",
	responsive = true,
}) => {
	return (
		<Row
			key={index}
			className="rounded-md w-full gap-4 shadow-md p-4 border border-gray-200"
			{...(responsive && { responsiveCol: responsive })}
		>
			{img && (
				<img
					src={img}
					alt={titulo || "Imagen"}
					draggable={false}
					className={`${classNameImg} shadow select-none`}
				/>
			)}

			<Column className="gap-1  w-full md:w-3/5">
				<Column className="gap-1 md:gap-2">
					{titulo && (
						<TextComponent
							variant="h5"
							className="font-semibold uppercase"
						>
							{titulo}
						</TextComponent>
					)}

					{descripcion && (
						<TextComponent
							variant="h7"
							className="text-gray-600"
						>
							{descripcion}
						</TextComponent>
					)}
				</Column>
				{children}
			</Column>
		</Row>
	);
};
